import { useState } from 'react';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';

const teamMembers = [
  {
    name: '张明远',
    role: '创始人 & CEO',
    bio: '资深电影爱好者，拥有15年互联网行业经验。怀揣"让每个人都能轻松看好电影"的愿景创立星空电影网。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%2C%20business%20casual%2C%20confident%20expression%2C%20modern%20office%20background%2C%20warm%20lighting%2C%20cinematic%20portrait%20style&width=400&height=400&seq=team-1&orientation=squarish',
  },
  {
    name: '李思雨',
    role: '内容总监',
    bio: '前知名影视媒体主编，对电影内容有独到的鉴赏力。负责片单策划与内容品质把控。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20smart%20casual%2C%20friendly%20smile%2C%20creative%20office%20environment%2C%20soft%20natural%20lighting%2C%20cinematic%20portrait&width=400&height=400&seq=team-2&orientation=squarish',
  },
  {
    name: '王浩然',
    role: '技术负责人',
    bio: '全栈工程师出身，专注视频流媒体技术。致力于打造流畅稳定的高清观影体验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20portrait%2C%20tech%20professional%2C%20modern%20startup%20office%2C%20relaxed%20confident%20pose%2C%20warm%20cinematic%20lighting%2C%20portrait%20photography&width=400&height=400&seq=team-3&orientation=squarish',
  },
];

const milestones = [
  { year: '2020', title: '星空电影网上线', description: '以"让观影更简单"为使命，正式推出星空电影网1.0版本，首批收录5000+部电影资源。' },
  { year: '2021', title: '用户突破100万', description: '凭借优质的内容和流畅的体验，月活用户突破100万大关，成为国内增长最快的电影平台之一。' },
  { year: '2022', title: '高清全面升级', description: '全面升级视频播放技术，实现全站高清画质覆盖，引入智能推荐算法，提升用户找片效率。' },
  { year: '2023', title: '分类体系重构', description: '重新构建电影分类体系，八大分类精准覆盖各类影迷需求。片单数量突破15000+部。' },
  { year: '2024', title: '月活突破500万', description: '月活跃用户突破500万，成为中文互联网最具影响力的免费电影平台之一，口碑持续走高。' },
  { year: '2025', title: 'AI智能推荐上线', description: '引入AI智能推荐系统，根据用户观影偏好精准推送，用户体验再上新台阶。' },
];

const testimonials = [
  {
    quote: '星空电影网是我每天必逛的网站，分类非常清晰，找片特别方便。画质也很好，完全免费真的很良心！',
    author: '资深影迷 - 陈先生',
    rating: 5,
  },
  {
    quote: '作为一个电影爱好者，星空电影网的片单更新速度让我很惊喜。新片上线很快，老片资源也很全。',
    author: '豆瓣影评人 - 林女士',
    rating: 5,
  },
  {
    quote: '界面简洁干净，没有烦人的广告，观影体验非常棒。我已经推荐给了身边所有喜欢看电影的朋友。',
    author: '大学生 - 赵同学',
    rating: 5,
  },
  {
    quote: '片库真的很大，从经典老片到最新大片都有。分类功能特别好用，想看什么类型的一下就能找到。',
    author: '自由职业者 - 周女士',
    rating: 5,
  },
];

export default function About() {
  const [formName, setFormName] = useState('');
  const [formEmail, setFormEmail] = useState('');
  const [formMessage, setFormMessage] = useState('');
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormStatus('success');
      setFormName('');
      setFormEmail('');
      setFormMessage('');
      return;
    }

    const formData = new FormData(form);
    try {
      const response = await fetch('https://readdy.ai/api/form/d9oc708bdkpk99j7gu2g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormName('');
        setFormEmail('');
        setFormMessage('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后再试';
        setFormError(serverMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络连接失败，请检查网络后重试');
      setFormStatus('error');
    }
  };

  const aboutSchema = {
    '@type': 'AboutPage',
    about: {
      '@type': 'Organization',
      name: '星空电影网',
      description: '星空电影网是一个专注于提供高清免费电影在线观看的平台，涵盖动作片、喜剧片、科幻片等丰富分类。',
      foundingDate: '2020',
      foundingLocation: '北京',
    },
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 星空电影网品牌介绍与联系方式"
        description="了解星空电影网的品牌故事、发展历程与核心团队。我们致力于为影迷提供最新最全的高清免费电影资源，分类清晰，片单齐全。"
        keywords="星空电影网,关于星空电影网,电影网站,品牌介绍,联系方式"
        canonicalUrl="https://www.xingkongmovie.com/about"
        schemaType="AboutPage"
        schemaData={aboutSchema}
      />

      <main className="pt-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: '关于我们' },
            ]}
          />
        </div>

        <section className="relative py-16 md:py-20 overflow-hidden" aria-label="品牌介绍">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20reel%20and%20film%20strip%20abstract%20background%2C%20warm%20golden%20and%20dark%20tones%2C%20artistic%20texture%2C%20vintage%20cinema%20aesthetic%2C%20subtle%20geometric%20patterns%2C%20elegant%20atmosphere&width=1600&height=600&seq=about-hero&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-background-50/85"></div>
          </div>
          <div className="relative max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-100 mb-4">
              关于星空电影网
            </h1>
            <p className="text-foreground-400 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              星空电影网创立于2020年，是一个专注于高清免费电影在线观看的平台。
              我们相信，好电影应该被更多人看到。五年来，我们始终秉持"让观影更简单"的理念，
              为数百万影迷提供最新、最全、最优质的电影资源。
            </p>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100/50" aria-label="发展历程">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-10">
              发展历程
            </h2>
            <div className="relative max-w-4xl mx-auto">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-200/70 transform md:-translate-x-px"></div>
              {milestones.map((item, index) => (
                <div
                  key={item.year}
                  className={`relative flex items-start gap-6 mb-8 ${
                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div className="absolute left-2 md:left-1/2 w-5 h-5 rounded-full bg-primary-500 border-4 border-background-50 transform -translate-x-1/2 z-10"></div>
                  <div className={`pl-10 md:pl-0 md:w-1/2 ${index % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12'}`}>
                    <span className="inline-block px-3 py-1 rounded-md text-xs font-bold bg-primary-500/20 text-primary-400 mb-2">
                      {item.year}
                    </span>
                    <h4 className="font-heading text-base font-semibold text-foreground-100 mb-2">
                      {item.title}
                    </h4>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                  {index % 2 === 0 ? <div className="hidden md:block md:w-1/2"></div> : <div className="hidden md:block md:w-1/2"></div>}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14" aria-label="核心团队">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
              核心团队
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-8 max-w-lg mx-auto">
              一群热爱电影的人，用心打造极致的观影体验
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {teamMembers.map((member) => (
                <div
                  key={member.name}
                  className="text-center p-6 rounded-lg bg-background-100 border border-background-200/50"
                >
                  <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden">
                    <img
                      src={member.imageUrl}
                      alt={member.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <h4 className="font-heading text-base font-semibold text-foreground-100 mb-1">
                    {member.name}
                  </h4>
                  <p className="text-xs text-primary-400 font-medium mb-3">{member.role}</p>
                  <p className="text-sm text-foreground-500 leading-relaxed">{member.bio}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100/50" aria-label="用户口碑">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
              用户口碑
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-8 max-w-lg mx-auto">
              来自真实用户的评价，是我们前进的最大动力
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
              {testimonials.map((item, index) => (
                <div
                  key={index}
                  className="p-5 rounded-lg bg-background-100 border border-background-200/50 flex flex-col"
                >
                  <div className="flex gap-0.5 mb-3">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-primary-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-400 leading-relaxed flex-1 mb-3">
                    &ldquo;{item.quote}&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">{item.author}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14" aria-label="联系我们" id="contact">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 text-center mb-8 max-w-lg mx-auto">
                如果您有任何建议、合作意向或问题反馈，欢迎随时联系我们
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/50 text-center">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10">
                    <i className="ri-mail-line text-xl text-primary-400"></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-100 mb-1">电子邮箱</h4>
                  <p className="text-sm text-foreground-500">contact@xingkongmovie.com</p>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/50 text-center">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-500/10">
                    <i className="ri-phone-line text-xl text-accent-400"></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-100 mb-1">客服电话</h4>
                  <p className="text-sm text-foreground-500">400-888-6666</p>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/50 text-center">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-500/10">
                    <i className="ri-time-line text-xl text-secondary-400"></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-100 mb-1">工作时间</h4>
                  <p className="text-sm text-foreground-500">周一至周日 9:00 - 21:00</p>
                </div>
              </div>

              <div className="bg-background-100 rounded-lg border border-background-200/50 p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-100 mb-5 text-center">
                  在线留言
                </h3>
                <form onSubmit={handleSubmit} className="max-w-lg mx-auto space-y-4" data-readdy-form>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <div>
                    <label htmlFor="contact-name" className="block text-sm text-foreground-400 mb-1">
                      姓名
                    </label>
                    <input
                      id="contact-name"
                      name="name"
                      type="text"
                      required
                      value={formName}
                      onChange={(e) => setFormName(e.target.value)}
                      className="w-full px-4 py-3 rounded-lg bg-background-50 border border-background-200/50 text-foreground-200 text-sm focus:outline-none focus:border-primary-500/50 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm text-foreground-400 mb-1">
                      邮箱
                    </label>
                    <input
                      id="contact-email"
                      name="email"
                      type="email"
                      required
                      value={formEmail}
                      onChange={(e) => setFormEmail(e.target.value)}
                      className="w-full px-4 py-3 rounded-lg bg-background-50 border border-background-200/50 text-foreground-200 text-sm focus:outline-none focus:border-primary-500/50 transition-colors"
                      placeholder="请输入您的邮箱地址"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm text-foreground-400 mb-1">
                      留言内容
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      value={formMessage}
                      onChange={(e) => setFormMessage(e.target.value)}
                      rows={4}
                      className="w-full px-4 py-3 rounded-lg bg-background-50 border border-background-200/50 text-foreground-200 text-sm focus:outline-none focus:border-primary-500/50 transition-colors resize-none"
                      placeholder="请输入您的留言内容（500字以内）"
                    />
                    <p className="text-xs text-foreground-600 mt-1 text-right">
                      {formMessage.length}/500
                    </p>
                  </div>
                  <button
                    type="submit"
                    className="w-full py-3 rounded-lg bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    发送留言
                  </button>

                  {formStatus === 'success' && (
                    <p className="text-sm text-green-400 text-center">留言发送成功！感谢您的反馈，我们会尽快回复。</p>
                  )}
                  {formStatus === 'error' && (
                    <p className="text-sm text-red-400 text-center">{formError || '发送失败，请稍后再试'}</p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}